import React from "react";
import { TCText } from "../../TCText/TCText";
import { Button } from "../../button/Button";
import { Colors } from "../../../utils/colors";

type props = {
  visible: boolean;
  title: string;
  description: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};

export const CustomDialog: React.FC<props> = ({
  visible,
  description,
  onCancel,
  onConfirm,
  title,
}) => {
  return visible ? (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1002,
      }}>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 16,
          padding: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "70%",
          maxWidth: "350px",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          flexDirection: "column",
          minHeight: "fit-content",
          maxHeight: "90vh",
          overflow: "auto",
          position: "relative",
        }}>
        <TCText
          style={{
            fontWeight: 600,
            fontSize: 16,
            color: "black",
            textAlign: "center",
          }}
          value={title}
        />

        <TCText
          style={{
            fontWeight: 500,
            fontSize: 14,
            color: "black",
            textAlign: "center",
            marginTop: 20,
          }}
          value={description}
        />
        <div style={{ display: "flex", gap: 5, width: "100%" }}>
          {onCancel && (
            <Button
              text="Cancel"
              onPress={onCancel}
              btnStyle={{
                width: "100%",
                backgroundColor: "transparent",
                marginTop: 20,
                height: 40,
                border: `2px solid ${Colors.darkBrown}`,
              }}
              textStyle={{ color: Colors.darkBrown }}
            />
          )}
          {onConfirm && (
            <Button
              text="OK"
              onPress={onConfirm}
              btnStyle={{
                width: "100%",
                backgroundColor: Colors.darkBrown,
                marginTop: 20,
                height: 40,
              }}
              textStyle={{ color: "white" }}
            />
          )}
        </div>
      </div>
    </div>
  ) : null;
};
